<template>
  <v-card>
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate color="primary"/>
    </v-overlay>

    <ac-data-table
      :headers="headers"
      :items="items"
      :item-class="row_class"
      item-key="uid"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 260"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Offers"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Offer
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload
        </v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-trader-offer-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TraderOffer} from "@/modules/redactor/models/trader/TraderOffer";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import RTraderOfferDialog from "@/modules/redactor/views/trader/r-trader-offer-dialog";
import {TimeUtils} from "@/common/TimeUtils";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  name: "r-trader-offer-page",
  components: {RDialogPreviewCollection, AcDataTable, RTraderOfferDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Name", value: "name"},
      {text: "Key", value: "key"},
      {text: "Order", value: "order"},
      {text: "Group", value: "group.name"},
      {text: "Level", value: "guard.level.string"},
      {text: "Quantity", value: "quantity"},
      {text: "Discount", value: "discount"},
      {text: "Multiplier", value: "multiplier"},
      {text: "Trader", value: "trader.name"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    loading: false,
    items: {
      type: VueTypes.arrayOf(TraderOffer)
    },
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs["dialog"].show(ViewRules.COPY, item.copy()).then(
        result => {
          RedactorUtils.pushTraderOffer(result).then(
            () => {
              this.$alert("Changes was published");
            });
        }, () => {
        });
    },
    row_create() {
      this.$refs["dialog"].show(ViewRules.CREATE, null).then(
        result => {
          RedactorUtils.pushTraderOffer(result).then(
            () => {
              this.$alert("Changes was published");
            });
        }, () => {
        });
    },
    row_update(item) {
      this.$refs["dialog"].show(ViewRules.UPDATE, item.clone()).then(
        result => {
          RedactorUtils.pushTraderOffer(result).then(
            () => {
              this.$alert("Changes was published");
            });
        }, () => {
        });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeTraderOffer(item).then(
          () => {
            this.$alert("Changes was published");
          });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkTraderOffers(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushTraderOffer(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, TraderOffer, "trader-offer")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getTraderOffers();
  }
}
</script>